"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactAriaModal = _interopRequireDefault(require("react-aria-modal"));

var _Button = require("../Button");

var _modalStyles = require("./modalStyles");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getApplicationNode() {
  return document.getElementById('root');
}

var nextId = 0;

function getId() {
  var id = "".concat(nextId);
  nextId += 1;
  return id;
}

var Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper(Modal);

  function Modal() {
    var _this;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "fallbackId", "modal-".concat(getId()));

    return _this;
  }

  _createClass(Modal, [{
    key: "getId",

    /* eslint-enable react/sort-comp */
    value: function getId() {
      var id = this.props.id;
      return id || this.fallbackId;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          footer = _this$props.footer,
          onRequestClose = _this$props.onRequestClose,
          size = _this$props.size,
          title = _this$props.title;
      var renderedFooter = footer;

      if (footer === undefined) {
        renderedFooter = /*#__PURE__*/_react.default.createElement(_Button.Button, {
          onClick: onRequestClose
        }, "Ok");
      }

      return /*#__PURE__*/_react.default.createElement(_reactAriaModal.default, {
        dialogId: this.getId(),
        focusDialog: true,
        getApplicationNode: getApplicationNode,
        onExit: onRequestClose,
        titleId: "".concat(this.getId(), "-title"),
        underlayStyle: _modalStyles.underlayStyle
      }, /*#__PURE__*/_react.default.createElement(_modalStyles.ModalContent, {
        className: "modal-content",
        size: size
      }, /*#__PURE__*/_react.default.createElement(_modalStyles.ModalHeader, null, /*#__PURE__*/_react.default.createElement(_modalStyles.ModalTitle, {
        id: "".concat(this.getId(), "-title")
      }, title), /*#__PURE__*/_react.default.createElement(_modalStyles.ModalHeaderCloseButton, {
        "aria-label": "Close",
        onClick: onRequestClose,
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/_react.default.createElement(_modalStyles.ModalBody, null, children), renderedFooter && /*#__PURE__*/_react.default.createElement(_modalStyles.ModalFooter, null, renderedFooter)));
    }
  }]);

  return Modal;
}(_react.Component);

exports.Modal = Modal;

_defineProperty(Modal, "propTypes", {
  children: _propTypes.default.node,
  footer: _propTypes.default.node,
  id: _propTypes.default.string,
  onRequestClose: _propTypes.default.func.isRequired,
  size: _propTypes.default.oneOf(['small', 'medium', 'large', 'xlarge']),
  title: _propTypes.default.string.isRequired
});

_defineProperty(Modal, "defaultProps", {
  children: undefined,
  footer: undefined,
  id: undefined,
  size: 'medium'
});